import { APP_BASE_HREF } from '@angular/common';
import { computed, Directive, inject, input } from '@angular/core';

import { checkUrlAbsolute, concatUrl } from '@lvflanders/bar';

import { BaasInteractiveElementOptions } from './baas-interactive-element-options';
import { _BarInteractiveElementBehavior } from './bar-interactive-element-behavior';

@Directive({
    selector: 'a[baasInteractiveElement]',
    host: {
        '[attr.href]': 'href()',
        '[attr.target]': 'baasInteractiveElement().target',
        '(click)': 'onClick($event)'
    }
})
export class BaasInteractiveElement {
    readonly #behavior = inject(_BarInteractiveElementBehavior);
    readonly #baseHref = inject<string>(APP_BASE_HREF, { optional: true });

    readonly baasInteractiveElement = input.required<BaasInteractiveElementOptions>();

    protected readonly href = computed(() => {
        const item = this.baasInteractiveElement();
        if (item.href) return item.href;
        if (item.routerUrl) {
            if (checkUrlAbsolute(item.routerUrl)) return item.routerUrl;
            return concatUrl(this.#baseHref || '/', item.routerUrl);
        }
        return null;
    });

    protected async onClick(event: MouseEvent): Promise<void> {
        event.stopPropagation();
        await this.#behavior.linkClick(event, this.baasInteractiveElement());
    }
}
